import { Button } from "../../nq-component";

export default function FloatingButton({ onClick }) {
  return (
    <div
      className="position-fixed"
      style={{ bottom: "2.5rem", right: "2.5rem" }}
    >
      <Button
        className="btn shadow-sm bg-primary"
        onClick={onClick}
        style={{
          width: "4rem",
          height: "4rem",
          borderRadius: "5rem",
        }}
      >
        <i className="bi bi-plus h1 text-white" />
      </Button>
    </div>
  );
}
